module.exports = __webpack_public_path__ + "media/accept.3047bf56.mp3";